import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'formataddress',
    standalone: false
})
export class FormatAddressPipe implements PipeTransform {
  public transform(value) {
    if (!value || Object.keys(value).filter(key => !!value[key]).length === 0) {
      return 'Address not on file';
    }

    return Object.keys(value)
      .filter(key => !!value[key])
      .map(key => value[key])
      .join(', ');
  }
}
